import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function StepSection({
  step_key,
  title,
  description,
  error,
  children,
  footer,
}: {
  step_key: string;
  title: string;
  description?: string;
  error?: string | null;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <Card data-testid={`step-content-${step_key}`}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>
        {error && (
          <div
            className="mb-4 rounded-md border border-destructive/20 bg-destructive/10 px-3 py-2 text-sm text-destructive"
            data-testid={`step-error-${step_key}`}
          >
            {error}
          </div>
        )}
        <div className="flex flex-col gap-5">{children}</div>
      </CardContent>
      {footer && <div className="flex flex-wrap items-center justify-end gap-3 border-t border-border px-6 py-4">{footer}</div>}
    </Card>
  );
}
